import request from '@/utils/sap-request'
import request2 from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

// 平账
export const apiBalanceAccounts = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao27',
    method: 'POST',
    data
  })
}

// 制票通知单查询
export const apiMakeInvoiceList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao06',
    method: 'POST',
    data
  })
}

// 制票通知单明细查询
export const apiMakeInvoiceDetailList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao07',
    method: 'POST',
    data
  })
}

// 根据制票id查询详情
export const apiGetDetailById = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao08',
    method: 'POST',
    data
  })
}

// 查询待开票销售订单明细查询
export const apiNoMakeInvoiceList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao01',
    method: 'POST',
    data
  })
}

// 删除或拆分
export const apiSplitOrDelete = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao03',
    method: 'POST',
    data
  })
}

// 工作台确认接口
export const apiConfirmItems = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao10',
    method: 'POST',
    data
  })
}

// 工作台查询详情
export const apiMakeInvoiceDetail = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/zhipiao11',
    method: 'POST',
    data
  })
}

// 提交
export const apiSubmit = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao02',
    method: 'POST',
    data
  })
}

// 将返回的数据提交给新系统
export const apiSaveSapInvinfo = (data) => {
  return request2({
    url: BASE_API() + '/Invinfo/saveSapInvinfo',
    method: 'POST',
    data
  })
}

// 审核通过和保存ESM单号
export const apiApprove = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/zhipiao09',
    method: 'POST',
    data
  })
}

// 修改特殊发票号
export const apiEditInvoice = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao12',
    method: 'POST',
    data
  })
}

// 制票通知单批导查询
export const apiInvoiceImportList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao15',
    method: 'POST',
    data
  })
}

// 制票通知单批导明细查询
export const apiInvoiceImportDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao17',
    method: 'POST',
    data
  })
}

// 制票通知单批导保存和取消
export const apiInvoiceImportCancelSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao18',
    method: 'POST',
    data
  })
}

// 制票通知单重传 开票/中转仓 系统
export const apiReSend = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao19',
    method: 'POST',
    data
  })
}

// 制票通知单 创建后续
export const apiCreateNext = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao20',
    method: 'POST',
    data
  })
}

// 制票通知批导
export const apiInvoiceImport = (data) => {
  return request2({
    url: BASE_API() + '/Invinfo/excelImport',
    method: 'POST',
    data
  })
}

// 制票通知批导
export const apiSapInvoiceImport = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao16',
    method: 'POST',
    data
  })
}

// 制票通知单详情打印
export const printInvoice = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao21',
    method: 'POST',
    data
  })
}

// 制票通知单打印EMS地址 发运单 签收表
export const printEMSAddress = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao22',
    method: 'POST',
    data
  })
}
// 保存导入的瓶储制票通知单修改数据
export const savePCImprotData = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/pc_zpd_modify',
    method: 'POST',
    data
  })
}
// 红冲制票通知单查询
export const apiGetRedRushList = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/GET_RED_RUSH',
    method: 'POST',
    data
  })
}
// 红冲制票通知单详情查询
export const apiGetRedRushId = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/GET_REDRUSH_ID',
    method: 'POST',
    data
  })
}
// 红冲提交
export const apiRedSubmit = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/red_rush',
    method: 'POST',
    data
  })
}
// 红冲数据生成
export const apiRedDataGet = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/GET_REDRUSH_SC',
    method: 'POST',
    data
  })
}
// 红冲详情数据生成
export const apiRedDetailDataGet = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/REDRUSH_SC_ID',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sap/make-invoice-sap.js